<script setup lang="ts">
import { cn } from '@/lib/utils'
import { Primitive, type PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { titleVariants, type TitleVariants } from '.'

interface Props extends PrimitiveProps {
    size?: TitleVariants['size']
    class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
    as: 'h2',
})
</script>

<template>
    <Primitive :as="as" :as-child="asChild" :class="cn(titleVariants({ size }), props.class)">
        <slot />
    </Primitive>
</template>
